angular.module('mercury.startup')
.config(["flowFactoryProvider", "$httpProvider", "settings", function(flowFactoryProvider, $httpProvider, settings) {
  flowFactoryProvider.defaults = {
    target: settings.apiHost + '/r/Image',
    testChunks: false,
    simultaneousUploads: 1,
    headers: function() {
      // Use the same header defaults as regular $http requests will use.
      return $httpProvider.defaults.headers.common;
    }
  };
}]);
